import { Branding } from '../../types/__generated__';
import { invertColor, isLightColor, shadeColor } from '../utils/colors';

export function createBranding(brandingData: Branding) {
  let branding = '';

  const {
    primaryColor,
    headerImage,
    backgroundColor,
    backgroundImage,
  } = brandingData;

  if (headerImage) {
    branding += `<meta name="jg:chrome:logoImageUrl" content="${headerImage}" />`;
  }
  if (primaryColor) {
    const secondaryColor = shadeColor(primaryColor);
    const tertiaryColor = invertColor(primaryColor, true);
    const primaryOrDark = isLightColor(primaryColor)
      ? tertiaryColor
      : primaryColor;

    branding += `<meta name="jg:chrome:brandingColor" content="${primaryColor}" />
        <style type="text/css" id="branding-styles">
            :root {
                --theme-primary: ${primaryColor};
                --theme-secondary: ${secondaryColor};
                --theme-tertiary: ${tertiaryColor};
                --theme-text-color: ${primaryOrDark};
                ${
                  backgroundColor
                    ? `--theme-background-color: ${backgroundColor.toUpperCase()};`
                    : ''
                }
                ${
                  backgroundImage
                    ? `--theme-background-image: url('${backgroundImage}');`
                    : ''
                }
            }
        </style>`;
  }
  return branding;
}

export type BrandingContent = {
  headerImage?: {
    tagName: string;
    content: string;
  };
  metaBranding?: {
    tagName: string;
    content: string;
  };
  styleBranding?: {
    id: string;
    content: string;
  };
};
export function createBrandingContent({
  primaryColor,
  headerImage,
  backgroundColor,
  backgroundImage,
}: Branding) {
  const brandingContent: BrandingContent = {
    headerImage: undefined,
    metaBranding: undefined,
    styleBranding: undefined,
  };

  if (headerImage) {
    brandingContent.headerImage = {
      tagName: 'jg:chrome:logoImageUrl',
      content: headerImage,
    };
  }

  if (primaryColor) {
    const secondaryColor = shadeColor(primaryColor);
    const tertiaryColor = invertColor(primaryColor, true);
    const primaryOrDark = isLightColor(primaryColor)
      ? tertiaryColor
      : primaryColor;

    brandingContent.metaBranding = {
      tagName: 'jg:chrome:brandingColor',
      content: primaryColor,
    };
    brandingContent.styleBranding = {
      id: 'branding-styles',
      content: `:root {
        --theme-primary: ${primaryColor};
        --theme-secondary: ${secondaryColor};
        --theme-tertiary: ${tertiaryColor};
        --theme-text-color: ${primaryOrDark};
        ${
          backgroundColor
            ? `--theme-background-color: ${backgroundColor.toUpperCase()};`
            : ''
        }
        ${
          backgroundImage
            ? `--theme-background-image: url('${backgroundImage}');`
            : ''
        }
    }`,
    };
  }

  return brandingContent;
}
